import { ShieldX } from 'lucide-react';
import { Button } from '@shared/ui';
import { signOutToLogin } from './signOut';

/**
 * Rendered when a user successfully authenticates with Cognito but is NOT a member of the `admin`
 * group. The whole app is gated behind this — there is no partial access. A clean, branded dead-end
 * with a single way out: sign out (and optionally sign in as a different, authorized account).
 */
export function NotAuthorizedPage({ email }: { email?: string }) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-canvas px-4">
      <div
        className="w-full max-w-md rounded-card bg-canvas-raised p-8 text-center shadow-card"
        style={{ border: '1px solid var(--canvas-divider)' }}
      >
        <div
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full"
          style={{ background: 'var(--loss-soft)' }}
        >
          <ShieldX className="h-7 w-7" style={{ color: 'var(--loss)' }} />
        </div>
        <h1 className="font-display text-xl font-bold tracking-tight text-text">Not authorized</h1>
        <p className="mt-2 text-sm text-text-muted">
          Your account isn&rsquo;t a member of the Optimus Journal admin group, so you can&rsquo;t
          access the backoffice console.
        </p>
        {email && (
          <p className="mt-1 text-xs text-text-subtle">
            Signed in as <span className="font-medium text-text-muted">{email}</span>
          </p>
        )}
        <p className="mt-4 text-xs text-text-subtle">
          If you believe this is a mistake, ask an administrator to add you to the
          <span className="font-mono"> admin </span>
          group, then sign in again.
        </p>
        <div className="mt-6 flex justify-center">
          <Button variant="primary" onClick={signOutToLogin}>Sign out</Button>
        </div>
      </div>
    </div>
  );
}
